import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import Clarity from '@microsoft/clarity';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ClarityService {
  private router = inject(Router);

  init(): void {
    if (!environment.clarityProjectId) return;

    Clarity.init(environment.clarityProjectId);
    Clarity.setTag('environment', environment.app_id || 'unknown');

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event) => {
      const pageName = this.resolvePageName((event as NavigationEnd).urlAfterRedirects);
      Clarity.setTag('page', pageName);
    });
  }

  identify(userId: string, userEmail?: string): void {
    if (!environment.clarityProjectId) return;
    Clarity.identify(userId, undefined, undefined, userEmail);
  }

  setTag(key: string, value: string | string[]): void {
    if (!environment.clarityProjectId) return;
    Clarity.setTag(key, value);
  }

  trackEvent(name: string): void {
    if (!environment.clarityProjectId) return;
    Clarity.event(name);
  }

  private resolvePageName(url: string): string {
    const path = url.split('?')[0];
    const segments = path.split('/').filter(Boolean);

    // First segment is the tenant code — skip it
    const pageSegments = segments.slice(1);

    // Strip dynamic IDs: UUIDs and purely numeric segments
    const idPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$|^\d+$/i;
    const meaningful = pageSegments.filter(s => !idPattern.test(s));

    if (!meaningful.length) return 'Home';

    return meaningful
      .map(s => s.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()))
      .join(' > ');
  }
}
